/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description saveSearchModal reducers
 */

import { defaultFilters } from '@zcode/nr/es/shared/bizos/filter'
import { falseReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { SaveSearchModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  DONE_CREATING_SAVED_SEARCH,
  ERROR_CREATING_SAVED_SEARCH,
  RECEIVE_DATA,
  START_CREATING_SAVED_SEARCH,
} from '../constants/saveSearchModal'
import type { ActionTypes } from '../types'

export const saveSearchReducer = combineReducers<SaveSearchModal, ActionTypes>({
  entity: handleAction<SaveSearchModal['entity'], ActionTypes, typeof RECEIVE_DATA>(
    RECEIVE_DATA,
    payloadKeyReducer('entity') ?? null,
    null
  ),
  filters: handleAction<SaveSearchModal['filters'], ActionTypes, typeof RECEIVE_DATA>(
    RECEIVE_DATA,
    payloadKeyReducer('filters'),
    defaultFilters
  ),
  origin: handleAction<SaveSearchModal['origin'], ActionTypes, typeof RECEIVE_DATA>(
    RECEIVE_DATA,
    payloadKeyReducer('origin'),
    ''
  ),
  loading: handleActions<SaveSearchModal['loading'], ActionTypes>(
    {
      [START_CREATING_SAVED_SEARCH]: trueReducer,
      [DONE_CREATING_SAVED_SEARCH]: falseReducer,
      [ERROR_CREATING_SAVED_SEARCH]: falseReducer,
    },
    false
  ),
})
